<template>
  <v-container fluid class="gallery-container">
    <!-- Two Buttons After Showing the Sample Cards -->
    <v-row v-if="!showSample" justify="end" class="mb-4">
      <BaseButton color="primary" outlined @click="showSample = false" :to="{ name: 'generate-id-card' }"
        class="mr-4 text-decoration-none">ID Card</BaseButton>
      <BaseButton color="primary" outlined @click="openModal">+ Choose My Card</BaseButton>
    </v-row>
    <StudentEmploee @studentType="handleChooseCard" />
    <v-row v-if="!loading" justify="start" align="start" class="d-flex flex-wrap">
      <v-col cols="12" sm="6" md="5" lg="3" xl="3" v-for="(chosen, index) in chosenCard" :key="index"
        class="pa-1 mr-3 border rounded elevation-1" :style="isDarkTheme
          ? { background: '#333' }
          : { background: 'linear-gradient(135deg, #7AC6D2, #F7CFD8)' }
          ">
        <v-card class="ma-3 elevation-3 rounded-lg overflow-hidden">
          <v-img :src="chosen.card?.image || 'https://via.placeholder.com/500'" alt="Card Image" class="angle-card-img"
            height="auto" contain>
            <v-overlay absolute class="d-flex align-center justify-center" opacity="0.1">
              <v-icon size="80" color="white">mdi-image</v-icon>
            </v-overlay>
          </v-img>
        </v-card>
        <v-card class="ma-3 elevation-3 rounded-lg overflow-hidden" :style="isDarkTheme ? { background: '#333' } : { background: '#A6D6D6' }
          ">
          <v-card-text class="py-4 px-5 text-left">
            {{ chosen.card?.name }}<br />
            <v-icon v-if="chosen.class_names?.length" size="18" class="mr-1">mdi-school</v-icon>
            <span v-if="chosen.class_names?.length">
              {{ chosen.class_names.join(", ") }}
            </span>
          </v-card-text>
          <v-card-footer class="d-flex justify-end align-center mb-2">
            <v-btn @click="openEditSample(chosen)" :style="isDarkTheme ? { background: '#333' } : { background: '#129990' }
              " class="me-2">
              Edit
            </v-btn>
            <v-btn @click="deleteCard(chosen)" :style="isDarkTheme ? { background: '#333' } : { background: '#129990' }
              " class="me-2">Delete Card</v-btn>
          </v-card-footer>
        </v-card>
      </v-col>
      <hr />
    </v-row>
    <!-- For edit section -->
    <v-skeleton-loader v-else type="text, image" class="elevation-1 mt-4"></v-skeleton-loader>
    <v-dialog v-model="isDialogOpen" max-width="600px">
      <v-card class="edit-dialog-card">
        <v-card-title class="headline edit-title">
          Edit {{ selectedCard.card?.name }}
        </v-card-title>

        <v-img :src="selectedCard.card?.image || noImage" alt="Card Image" class="angle-card-img edit-image"
          height="auto" contain />
        <v-row v-if="selectedCardPages === 'employee'">
          <v-col v-for="(card, index) in cards" :key="index" cols="12" sm="5" md="3" class="mb-4 ml-9">
            <v-card class="angle-card" elevation="4">
              <v-img :src="card.image ? card.image : noImage
                " alt="Card Image" class="angle-card-imgs" contain />
            </v-card>
            <v-radio-group v-model="selectedCard.card" :value="card">
              <!-- <v-radio-group v-model="selectedCard" :value="card"> -->
              <v-radio :label="card.name" :value="card" class="mx-auto" />
            </v-radio-group>
          </v-col>
        </v-row>
        <!-- <v-row></v-row> -->
        <v-row v-else>
          <v-card-text class="edit-content">
            <!-- <v-row v-if="selectedCard.class_info_names && selectedCard.class_info_names.length"> -->
            <v-col cols="12" sm="6" md="6" class="edit-select-col">
              <v-select v-model="selectedClassInfo" :items="selectItems" item-title="name" item-value="id"
                label="Class Detail*" multiple class="my-4" />
            </v-col>
          </v-card-text>
        </v-row>
        <v-row class="justify-end m-2">
          <!-- <v-btn class="me-2" @click="deleteCard">Delete Card</v-btn> -->
          <v-btn class="me-2" @click="updateCard">Submit</v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- for open samples card -->
    <v-dialog v-model="showDialog" max-width="900px">
      <v-card class="scrollable-div">
        <v-card-title class="headline">
          <v-typography variant="h5" class="modal-title">Choose My Card</v-typography>
          <v-btn icon @click="showDialog = false" class="square-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-btn color="primary" outlined @click="fetchSampleCards('student')" class="mr-4 mb-3">Student ID Card
          </v-btn>
          <v-btn color="primary" @click="fetchSampleCards('employee')" class="mr-4 mb-3">Employee ID Card
          </v-btn>
        </v-card-text>

        <v-card-body>
          <v-row>
            <v-col v-for="(card, index) in cards" :key="index" cols="12" sm="5" md="3" class="mb-4 ml-9">
              <v-card class="angle-card" elevation="4">
                <!-- <div class="image-wrapper"> -->
                <v-img :src="card.image
                  ? card.image
                  : 'https://via.placeholder.com/500'
                  " alt="Card Image" class="angle-card-imgs" contain />
                <!-- </div> -->
              </v-card>
              <v-radio-group v-model="selectedCard" :value="card">
                <v-radio :label="card.name" :value="card" class="mx-auto" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6" class="mb-4 ml-9" v-if="type === 'student'">
              <!-- <v-select v-model="classsInfoList.class_info" :items="filteredClasses" item-title="name" item-value="id"
                label="Class Detail*" required multiple class="my-4" /> -->
                <v-select v-model="selectedClassInfo" :items="selectItems" item-title="name" item-value="id"
                label="Class Detail*" multiple class="my-4" />
            </v-col>
          </v-row>
        </v-card-body>
        <v-divider></v-divider>
        <v-row class="justify-end mr-3">
          <v-btn color="primary" outlined @click="submitSelection" class="mr-4 mb-2">Submit</v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-row v-if="error">
      <v-col cols="12" class="text-center">
        <span class="text-danger">{{ error }}</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted, onBeforeMount, computed, watch } from "vue";
import BaseButton from "@/components/Apps/cardSample/BaseButton.vue";
import StudentEmploee from "@/components/Apps/cardSample/StudentEmploee.vue";
import {
  sample,
  classNames,
  getAssignedCard,
  postSampleCards,
  schoolDetail,
  UpdateSampleCards,
  deleteSampleCards,
} from "@/services/apiServices";
import { useTheme } from "@/composables/useThemes";
const { isDarkTheme } = useTheme();
import Swal from "sweetalert2";
import noImage from "@/assets/images/image_not_available-removebg-preview (1).png"

const cards = ref([]);
const loading = ref(false);
const error = ref("");
const showSample = ref(false);
const showDialog = ref(false);
const isDialogOpen = ref(false);
const selectedCard = ref(null);
const selectedCardPages = ref(null);

const type = ref(null);

const classsInfoList = ref([]);
const chosenCard = ref([]);
const schoolId = ref();
const schoolInfoList = ref({});
const filteredClasses = ref([]);
const selectedClassInfo = ref([]);

const classList = computed(() =>
  filteredClasses.value.map((c) => ({ id: c.id, name: c.name }))
);

const selectItems = computed(() => [
  { id: "all", name: "Select All" },
  ...classsInfoList.value.map((c) => ({ id: c.id, name: c.name })),
]);

// console.log("filteredClasses", filteredClasses.value);
// console.log("chosenCard", chosenCard);

watch(selectedClassInfo, (newVal) => {
  const allIds = classList.value.map((c) => c.id);
  const hasAll = newVal.includes("all");
  // console.log("selectedClassInfo", selectedClassInfo.value);
  if (hasAll) {
    if (newVal.length >= allIds.length) {
      selectedClassInfo.value = [];
    } else {
      selectedClassInfo.value = [...allIds];
    }
  }
  classsInfoList.value.class_info = selectedClassInfo.value;
});

watch(isDialogOpen, (isOpen) => {
  if (isOpen && selectedCard.value) {
    // Find the matching card from chosenCard
    const card = chosenCard.value.find((c) => c.id === selectedCard.value.id);
    if (selectedCardPages.value === "student") {
      if (card) {
        // Pre-fill selectedClassInfo with existing class_info
        selectedClassInfo.value = [...card.class_info];
      } else {
        selectedClassInfo.value = [];
      }
    }
  }
});

// watch(
//   [classsInfoList, chosenCard],
//   () => {
//     console.log("classsInfoList", classsInfoList.value);
//     filteredClasses.value = classsInfoList.value.filter(
//       (classItems) =>
//         !chosenCard.value.some((card) =>
//           card.class_info.includes(classItems.id)
//         ),
//     );
//     console.log("filteredClasses", filteredClasses.value);
//     console.log("chosenCard", chosenCard);
//   },
//   { immediate: true }
// );

const fetchSchool = async () => {
  try {
    const data = await schoolDetail();
    schoolInfoList.value = data;
    // console.log("schoolInfoList", schoolInfoList);
    // console.log("schoolInfoList", schoolInfoList.value.id);
    schoolId.value = Array.isArray(data)
      ? data.map((school) => school.id)
      : [data.id];
  } catch (err) {
    console.error("Failed to load school details:", err);
  }
};

const fetchClasss = async () => {
  try {
    const data = await classNames();
    classsInfoList.value = data;
    // console.log("classsInfoList", classsInfoList.value);
  } catch (err) {
    error.value = err.response?.data?.message || "Failed to load classes";
    console.error("Error fetching class details:", err);
  }
};

const fetchSampleCards = async (cardType) => {
  // console.log("fetchSampleCards called with cardType:", cardType);
  loading.value = true;
  try {
    const data = await sample(cardType);
    cards.value = data;
    // console.log("Sample cards:", cards.value);
    type.value = cardType;
  } catch (err) {
    error.value = err.response?.data?.message || "Failed to load cards";
    console.error("Error fetching sample cards:", err);
  } finally {
    loading.value = false;
  }
};
// for opening sample card modal
const openModal = async () => {
  selectedCard.value = null;
  await fetchClasss();
  // classsInfoList.value = [];
  filteredClasses.value = classsInfoList.value.filter(
    (classItems) =>
      !chosenCard.value.some((card) => card.class_info.includes(classItems.id))
  );
  // filteredClasses.value = [...classsInfoList.value];
  showDialog.value = true;
};

const fetchAssignedCards = async (cardType) => {
  loading.value = true;
  try {
    const data = await getAssignedCard(cardType);
    // console.log("fetchAssigned=>", data);
    chosenCard.value = data.choosen_cards.map((card) => ({
      ...card,
      class_info_names: card.class_info.map((classId) => {
        const match = classsInfoList.value.find((info) => info.id === classId);
        return match ? match.name : null;
      }),
    }));
  } catch (err) {
    error.value =
      err.response?.data?.message || "Failed to load assigned cards";
    console.error("Error fetching assigned cards:", err);
  } finally {
    loading.value = false;
  }
};

const submitSelection = async () => {
  error.value = null;
  loading.value = true;
  try {
    if (!selectedCard.value) {
      // console.log("selectedCard.value", selectedCard.value);
      error.value = "Please select a card";
      return;
    }
    const payload = {
      card: selectedCard.value.id,
      card_name: selectedCard.value.name,
      school: schoolInfoList.value.id,
    };
    if (type.value === "student") {
      payload.class_info = Array.isArray(classsInfoList.value.class_info)
        ? classsInfoList.value.class_info
        : [classsInfoList.value.class_info?.id];
    } else {
      payload.class_info = [];
    }
    await postSampleCards(payload);

    showDialog.value = false;
    fetchAssignedCards(type.value);

    Swal.fire({
      icon: "success",
      title: "Card chosen successfully",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      background: isDarkTheme.value ? "#333" : "#fff",
      color: isDarkTheme.value ? "#fff" : "#000",
      iconColor: isDarkTheme.value ? "#0f0" : "#28a745",
    });
  } catch (err) {
    error.value =
      err.response?.data?.message || "Failed to submit card selection";
    console.error("Error submitting selection:", err);
  } finally {
    loading.value = false;
    selectedClassInfo.value = [];
  }
};

const handleChooseCard = async (cardType) => {

  await fetchClasss();
  selectedCardPages.value = cardType;
  await fetchSampleCards(cardType);
  await fetchAssignedCards(cardType);
};

const openEditSample = (chosen) => {
  selectedCard.value = chosen;
  filteredClasses.value = classsInfoList.value.filter(
    (classItem) => !chosen.class_info.includes(classItem.id)
  );
  isDialogOpen.value = true;
};

const deleteCard = async (chosen) => {
  selectedCard.value = chosen;
  const cardId = selectedCard.value.id;
  // console.log("cardId", cardId);
  if (!cardId) {
    error.value = "No card selected for deletion";
    return;
  }
  try {
    await deleteSampleCards(cardId);
    Swal.fire({
      icon: "success",
      title: "Card deleted successfully",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      background: isDarkTheme.value ? "#333" : "#fff",
      color: isDarkTheme.value ? "#fff" : "#000",
      iconColor: isDarkTheme.value ? "#0f0" : "#28a745",
    });
    isDialogOpen.value = false;
    await fetchSampleCards(type.value);
    await fetchAssignedCards(type.value);
  } catch (err) {
    error.value = err.response?.data?.message || "Failed to delete card";
    console.error("Error deleting card:", err);
  }
};
const updateCard = async () => {
  const cardId = selectedCard.value.id;
  error.value = null;
  loading.value = true;
  try {
    let classInfo = [];
    if (selectedCardPages.value === "student") {
      const updatedData = { ...classsInfoList.value };
      classInfo = updatedData.class_info || [];
    }
    // console.log("selectedCard", selectedCard.value);
    const payload = {
      school: schoolInfoList.value.id,
      card: selectedCard.value.id,
      Choosen_card: selectedCard.value.card.id,
      card_name: selectedCard.value.card?.name,
      class_info: classInfo,
      valid_date: "2081-12-30",
    };
    
    if (selectedCardPages.value === "student") {
      payload.class_info = Array.isArray(classInfo)
      ? classInfo
      : [classInfo?.id];
    } else {
      delete payload.class_info;
    }
    // console.log("payload", payload);
    await UpdateSampleCards(payload);
    const response = await fetchAssignedCards(type.value);
    // console.log("Fetched assigned cards:", response);
    Swal.fire({
      icon: "success",
      title: "Card updated successfully",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      background: isDarkTheme.value ? "#333" : "#fff",
      color: isDarkTheme.value ? "#fff" : "#000",
      iconColor: isDarkTheme.value ? "#0f0" : "#28a745",
    });
  } catch (err) {
    console.error("Error updating card:", err);
  } finally {
    loading.value = false;
    selectedClassInfo.value = [];
    classsInfoList.value.class_info = [];
    isDialogOpen.value = false;
    await fetchSampleCards(type.value);

  }
};
// const updateCard = async () => {
//   let cardId = selectedCard.value.id;
//   const updatedData = { ...classsInfoList.value };
//   const classInfo = updatedData.class_info || [];
//   error.value = null;
//   loading.value = true;
//   try {
//     await UpdateSampleCards(cardId, classInfo);
//     const response = await fetchAssignedCards(type.value);
//     console.log("Fetched assigned cards:", response);
//     Swal.fire({
//       icon: "success",
//       title: "Card updated successfully",
//       toast: true,
//       position: "top-end",
//       showConfirmButton: false,
//       timer: 3000,
//       timerProgressBar: true,
//       background: isDarkTheme.value ? "#333" : "#fff",
//       color: isDarkTheme.value ? "#fff" : "#000",
//       iconColor: isDarkTheme.value ? "#0f0" : "#28a745",
//     });
//   } catch (err) {
//     console.error("Error updating card:", err);
//   } finally {
//     loading.value = false;
//     selectedClassInfo.value = [];
//     classsInfoList.value.class_info = [];
//     isDialogOpen.value = false;
//     await fetchSampleCards(type.value);
//   }
// };

onMounted(async () => {
  await fetchSchool();
  await fetchClasss();
  await handleChooseCard("student");
  await fetchSampleCards("student");
  // await fetchAssignedCards()
});
</script>

<style scoped>
.headline {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8f8;
  padding: 0.8rem 1.4rem;
  border-bottom: 0 solid #ebe9f1;
  border-top-left-radius: 0.357rem;
  border-top-right-radius: 0.357rem;
}

.modal-title {
  font-size: 1.3rem;
  /* font-weight: 550; */
  margin-bottom: 0;
  line-height: 1.45;
  /* font-family: 'Inria Serif', serif; */
}

.square-btn {
  width: 40px;
  height: 40px;
  background-color: rgb(221, 198, 245);
}

.scrollable-div::-webkit-scrollbar {
  width: 5px;
  height: 23px;
}

.scrollable-div::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.scrollable-div::-webkit-scrollbar-thumb {
  background: #c4c3fa;
  border-radius: 10px;
}

.scrollable-div::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.gallery-container {
  padding: 16px;
}

.image-wrapper {
  padding: 10px;
}

/* .angle-card-img {
  width: 60%;
  height: 60%;
  object-fit: contain;
} */

.angle-card-imgs {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.text-danger {
  color: red;
}

.small-card {
  max-width: 200px;
  margin: 0 auto;
}

.large-card {
  max-width: 500px;
  margin: 0 auto;
}

.edit-dialog-card {
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.edit-title {
  background-color: #85ac79;
  color: white;
  padding: 16px;
  font-weight: 600;
}

.edit-image {
  max-height: 250px;
  object-fit: cover;
  border-bottom: 4px solid #129990;
}

.edit-content {
  padding: 20px;
}

.edit-select-col {
  padding-left: 24px !important;
}

.edit-actions {
  justify-content: flex-end;
  padding: 16px;
}
</style>
